import { passwordPolicyQuery } from "@common/api/password-policy"
import { queryClient } from "@common/lib/query-client"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/_layout/settings")({
  beforeLoad: async () => {
    await queryClient.ensureQueryData(passwordPolicyQuery())
  },
})
